import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

//import SourceLink from 'components/SourceLink';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          &copy; 2020 PT PHAROS Indonesia
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
